<template>
  <q-btn-group flat>
    <q-btn
      v-for="resourceGroup in resourceGroups"
      :key="resourceGroup.label"
      :label="resourceGroup.label"
      size="sm"
      :color="getColor(resourceGroup)"
      :text-color="getTextColor(resourceGroup)"
      @click="$emit('update:modelValue', resourceGroup)"
    />
  </q-btn-group>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ResourceGroup, resourceGroups } from '.';

interface Data {
  resourceGroups: ResourceGroup[]
}

export default defineComponent({
  emits: ['update:modelValue'],
  props: {
    modelValue: Object as () => ResourceGroup,
  },
  data(): Data {
    return {
      resourceGroups,
    };
  },
  methods: {
    isSelected(resourceGroup: ResourceGroup): boolean {
      if (!this.modelValue) return false;
      return (this.modelValue.label === resourceGroup.label);
    },
    getColor(resourceGroup: ResourceGroup): string|undefined {
      return this.isSelected(resourceGroup) ? 'light-blue-1' : undefined;
    },
    getTextColor(resourceGroup: ResourceGroup): string|undefined {
      return this.isSelected(resourceGroup) ? 'dark' : undefined;
    },
  },
});
</script>
